import { render } from "./DateSelector.vue?vue&type=template&id=2366f771&scoped=true&lang=pug"
import script from "./DateSelector.vue?vue&type=script&lang=js"
export * from "./DateSelector.vue?vue&type=script&lang=js"

import "./DateSelector.vue?vue&type=style&index=0&id=2366f771&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2366f771"]])

export default __exports__